import { formatCurrency } from './formatCurrency';
import { roundToNearest } from './roundToNearest';

/** Steps for LTC cost rounding dropdown: 0 = precise, 10 | 100 | 1000 = round to that step. */
export const LTC_COST_ROUNDING_STEPS = [0, 10, 100, 1000] as const;

/** Derives rounding step from advisor settings. Default precise (0) when undefined. */
export function getLtcCostRoundingStep(
  ltcCostDisplayPrecision?: LtcCostDisplayPrecision,
): 0 | 10 | 100 | 1000 {
  if (ltcCostDisplayPrecision != null) {
    switch (ltcCostDisplayPrecision) {
      case 'precise':
        return 0;
      case '10':
        return 10;
      case '100':
        return 100;
      case '1000':
        return 1000;
      default:
        return 0;
    }
  }
  return 0;
}

export interface FormatLtcCostDisplayResult {
  displayValue: number;
  formattedDisplay: string;
  formattedPrecise: string;
}

/**
 * Returns display value and formatted strings for projected LTC cost.
 * roundingStep 0 = precise (no rounding); 10 | 100 | 1000 = round to that step.
 * Normalizes to whole dollars first so rounded display matches the "Precise" tooltip.
 */
export function formatLtcCostDisplay(
  value: number | undefined | null,
  options: { roundingStep: number },
): FormatLtcCostDisplayResult {
  const num = value ?? 0;
  const preciseValue = Math.round(num);
  const displayValue =
    options.roundingStep === 0
      ? preciseValue
      : roundToNearest(preciseValue, options.roundingStep);
  return {
    displayValue,
    formattedDisplay: formatCurrency(displayValue),
    formattedPrecise: formatCurrency(preciseValue),
  };
}
